import { useEffect, useState } from 'react';

import { DontExistsItem } from '../../../components/DontExistsItem';
import { DontExistsItemFlex } from '../../../components/DontExistsItem/styles';
import { ListCardsReleasedCollect } from '../../../components/List/Collects/ListCardsReleasedCollect';
import { ListReleasedCollects } from '../../../components/List/ListReleasedCollects';
import { LoadingData } from '../../../components/LoadingData';
import { PageHeader, ViewMode } from '../../../components/PageHeader';
import { Paginator } from '../../../components/Paginator';
import { useSigninContext } from '../../../context/AuthProviderPages/Signin';
import { useReleasedCollectContext } from '../../../context/ProviderPage/Liberar';
import { usePageContext } from '../../../context/usePage';
import { ContainerPage, PageContent } from '../../../styles/global.styles';

const Liberar = () => {
  const { setSelectedPage } = usePageContext();
  const [modifyViewMode, setModifyViewMode] = useState<ViewMode>({
    have: true,
    mode: 'card',
  });
  const {
    loadingReleasedCollect,
    releasedCollect,
    openSideModalFilterReleasedCollectAction,
    setOfsset,
    limit,
    offset,
    quantity,
    page,
    setPage,
    setHasClick,
    start,
    setStart,
    loadReleasedCollectAction,
  } = useReleasedCollectContext();

  const { user } = useSigninContext();

  useEffect(() => {
    if (user) {
      setSelectedPage({ option: 'liberar' });
      loadReleasedCollectAction();
    }
  }, [user]);

  return (
    <>
      <PageHeader
        {...{
          pageIcon: { option: 'liberar' },
          pageTitle: 'A liberar',
          filterAction: openSideModalFilterReleasedCollectAction,
          modifyViewMode,
          setModifyViewMode,
        }}
      />

      <ContainerPage>
        <PageContent
          style={{
            justifyContent: `${
              loadingReleasedCollect === true ? 'center' : 'space-between'
            }`,
          }}
        >
          {loadingReleasedCollect ? (
            <LoadingData title="Buscando dados" />
          ) : (
            <>
              {releasedCollect.length === 0 ? (
                <DontExistsItemFlex>
                  <DontExistsItem title="Nenhuma descarga foi encontrada!" />
                </DontExistsItemFlex>
              ) : (
                <>
                  {modifyViewMode.mode === 'normal' ? (
                    <ListReleasedCollects data={releasedCollect} />
                  ) : (
                    <ListCardsReleasedCollect data={releasedCollect} />
                  )}

                  <Paginator
                    {...{
                      start,
                      setStart,
                      limitItens: limit,
                      offset,
                      page,
                      quantity,
                      setHasClick,
                      setOfsset,
                      setPage,
                      quantityShowed: releasedCollect.length,
                    }}
                  />
                </>
              )}
            </>
          )}
        </PageContent>
      </ContainerPage>
    </>
  );
};

export { Liberar };
